import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { boilersHeatingLp } from "@/content/landing/boilers-heating";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpBoilersHeatingPage = lazyNamed(
  () => import("@/components/landing/lp-boilers-heating"),
  "LpBoilersHeating",
);

const PATH = "/boilers-heating";
const TITLE = "Boilers & Heating South Wales | Gas Safe | CRS Energy";
const DESCRIPTION =
  "Boiler replacements and heating upgrades across South Wales. Gas Safe registered engineers, manufacturer-backed warranty, free assessment and property-specific quotes.";

export const Route = createFileRoute("/boilers-heating")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Boilers & Heating",
        description: DESCRIPTION,
        serviceType: "Boilers & Heating",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: boilersHeatingLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpBoilersHeatingPage,
});
